<template>
    <div class="synonyms-item">
        <div class="synonyms-item-form">
            <div class="item-head">
                <input
                    class="form-input"
                    v-model="entry.value"
                    :placeholder="$t('chatbotv2.title')"
                    :autofocus="true"
                />
                <div class="delete-item" @click="deleteEntry">
                    <md-icon>delete</md-icon>
                </div>
            </div>
            <a-select
                class="form-select-input"
                mode="tags"
                :placeholder="$t('chatbotv2.synonyms')"
                @blur="synonymInputBlurHandler"
                v-model="entry.synonyms"
                :autofocus="true"
            >
                <a-select-option v-for="i in entry.synonyms" :key="i">
                    {{ i }}
                </a-select-option>
            </a-select>
        </div>
    </div>
</template>
<script>
import SynonymItem from "../../components/SynonymItem";

export default {
    name: "EntriesListItem",
    props: ["initialData", "open", "onOpened", "onClosed"],
    components: {
        SynonymItem,
    },
    data() {
        return {
            synonymText: "",
            entry: {
                value: "",
                synonyms: [],
            },
        };
    },
    methods: {
        synonymInputBlurHandler() {
            if (this.synonymText.length > 0) {
                this.synonymText = "";
            }
        },
        deleteEntry() {
            this.onClosed();
            this.$emit("delete-entry", this.entry.value || "");
        },
    },
    mounted() {
        this.entry = this.$_.cloneDeep({
            value: this.initialData.value,
            synonyms: this.initialData.synonyms.map((e) => e.value),
        });
    },
    watch: {
        entry: {
            deep: true,
            handler() {
                const entry = {
                    value: this.entry.value,
                    synonyms: this.entry.synonyms.map((value) => ({ value })),
                };
                this.$emit("update-entry", entry);
            },
        },
    },
};
</script>
<style lang="scss">
.synonyms-item {
    width: 100%;

    .synonyms-item-form {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .item-head {
            display: flex;
            align-items: center;
            gap: 4px;
            .delete-item {
                width: 30px;
                height: 30px;
                border-radius: 3px;
                background: dodgerblue;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                i {
                    color: white;
                }
            }
        }
    }
}
</style>
